// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3w1Hp","rootSmall":"AddTileButton_rootSmall__AMiQV"};